import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { getPageKeyLabel } from "@/modules/cms/domain/cms-labels";
import type { CmsContentHomeContentForm } from "@/modules/cms/domain/contracts";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate, useRouter, useSearch } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useCmsSectionsQuery, useCreateCmsSection } from "../api/queries";
import { HomeContentForm } from "../ui/forms/HomeContentForm";

export function CmsSectionCreatePage() {
  const router = useRouter();
  const nav = useNavigate({ from: "/app/cms/sections/new" });
  const search = useSearch({ from: "/app/cms/sections/new" }) as {
    pageKey?: string;
  };
  const pageKey = search.pageKey ?? "home";
  const createSection = useCreateCmsSection(pageKey);
  const sectionsQuery = useCmsSectionsQuery("home");
  const nextSortOrder =
    sectionsQuery.data && sectionsQuery.data.length > 0
      ? Math.max(...sectionsQuery.data.map((s) => s.sortOrder), 0) + 1
      : 0;

  const handleSubmit = async (content: CmsContentHomeContentForm) => {
    await createSection.mutateAsync({
      pageKey: "home",
      sectionKey: "home.content",
      content,
      sortOrder: nextSortOrder,
    });
    router.history.back();
  };

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ສ່ວນຫນ້າເວັບ", to: "/app/cms/sections" },
            { label: "ສ້າງໃໝ່" },
          ]}
        />
      </Header>
      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="font-bold text-2xl tracking-tight">
              ສ້າງ Section ບລ໋ອກສິນຄ້າ
            </h2>
            <p className="text-muted-foreground text-sm">
              ຫນ້າ: {getPageKeyLabel(pageKey)} — ສ້າງບລ໋ອກສິນຄ້າໃນຫນ້າຫຼັກ (ຫົວຂໍ້ + layout
              preset)
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/cms/sections" })}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <div className="mt-6 rounded-xl border bg-card p-6">
          <HomeContentForm
            content={null}
            onSubmit={handleSubmit}
            onCancel={() => router.history.back()}
            submitting={createSection.isPending}
          />
        </div>
      </Main>
    </>
  );
}
